import type { RouteRecordRaw } from 'vue-router';

export const webhookRoutes: RouteRecordRaw[] = [
  {
    path: 'webhooks',
    name: 'Webhooks',
    component: () => import('@/features/tenant/webhooks/pages/WebhooksPage.vue'),
    meta: { menuKey: 'webhooks' },
  },
];
